import { render, staticRenderFns } from "./sart.vue?vue&type=template&id=12afb7a4&"
import script from "./sart.vue?vue&type=script&lang=ts&"
export * from "./sart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports